import {FileNode} from 'substance'

class DWFileNode extends FileNode {

    handleDocument(xmlString, context) {
        return new Promise((resolve, reject) => {
            try {
                let doc = this.document

                if (!doc.get(this.parentNodeId)) {
                    // pdf file node may exists (in order to be able to undo/redo)
                    // but pdf node is not present, just resolve.
                    return resolve()
                }

                const parser = new DOMParser()

                let newsItemDOM = parser.parseFromString(xmlString, 'text/xml')
                let document = newsItemDOM.documentElement

                // Update fileNode
                const uuid = document.getAttribute('guid')
                const uri = this._parseIMUri(document)
                doc.set([this.id, 'uuid'], uuid)
                doc.set([this.id, 'uri'], uri)

                // Get parentNode
                const parentNode = doc.get(this.parentNodeId)
                if (parentNode.handleDOMDocument) {
                    parentNode.handleDOMDocument(newsItemDOM, context)
                }

                resolve()
            }
            catch (e) {
                reject(e)
            }
        })
    }

    _parseIMUri(newsItemElement) {
        const itemMeta = newsItemElement.getElementsByTagName('itemMeta').item(0)
        const itemMetaExtPropertyList = itemMeta.getElementsByTagName('itemMetaExtProperty')

        for (let i = 0; i < itemMetaExtPropertyList.length; i++) {
            const itemMetaExtProperty = itemMetaExtPropertyList.item(i)
            if ('imext:uri' === itemMetaExtProperty.getAttribute('type')) {
                return itemMetaExtProperty.getAttribute('value')
            }
        }
        return null
    }
}

DWFileNode.type = 'npfile'
DWFileNode.define({
    parentNodeId: {type: 'string', optional: false},
    imType: {type: 'string', optional: false},
    uuid: {type: 'string', optional: true},
    url: {type: 'string', optional: true},
    sourceFile: {type: 'object', optional: true}, // If we upload from a file
    sourceUrl: {type: 'string', optional: true}, // Upload from an url
    sourceUUID: {type: 'string', optional: true}, // Added from an existing item that has a UUID
    uri: {type: 'string', optional: true} // Infomaker uri, e.g. im://image/5et6oDDUkxRmK8Aus1mLMY_a8_s.jpg
})

export {DWFileNode}
